module.exports = __webpack_public_path__ + "static/media/envLowPoly.d142ae5a.glb";